type ApiErrorBody = {
  errors?: string[];
  error?: string;
};

export class ApiError extends Error {
  status: number;
  statusText: string;
  body?: ApiErrorBody;

  constructor(status: number, statusText: string, body?: ApiErrorBody) {
    const defaultMessage = `API request failed: ${status} ${statusText}`;

    let errorMessage: string | undefined;
    if (body?.error) {
      errorMessage = body.error;
    } else if (body?.errors?.length) {
      errorMessage = body.errors.join('\n');
    }

    super(errorMessage || defaultMessage);

    this.name = 'ApiError';
    this.status = status;
    this.statusText = statusText;
    this.body = body;
  }
}
